import { ref, shallowRef, onMounted } from 'vue'
import { get, setValueByPathToVue } from '../../../utils/index'

/***
 * 处理先决条件
 */
export function usePrecondition({
  preconditionFormItemsUrl,
  preconditionFormItems,
  preconditionFormItemsCode,
  preconditionDataInit,
}) {
  const preconditionRef = ref(null)
  const preconditionData = ref(preconditionDataInit ?? {})
  const preconditionForm = shallowRef({})

  const getData = async () => {
    if (preconditionFormItems) {
      return preconditionFormItems
    } else if (preconditionFormItemsCode) {
      const [res] = await get(`${preconditionFormItemsUrl}${preconditionFormItemsCode}`)
      return res.data ?? {}
    } else {
      return null
    }
  }
  const getPreconditionFormItems = async () => {
    const items = await getData()
    const tempItems = Array.isArray(items) ? { items } : items
    preconditionForm.value = tempItems
      ? {
          ...tempItems,
          form: {
            ...tempItems?.form,
            property: {
              colNum: 6, //number，一行展示多少列, 如: 5
              formGroup: false, //Boolean, 是否根据配置的formGroup组件进行分组
              labelPosition: 'left',
              ...tempItems?.form?.property,
            },
          },
        }
      : null
  }

  const setPreconditionData = (data, key) => {
    if (!key) {
      preconditionData.value = data
    } else {
      setValueByPathToVue(preconditionData.value, key, data)
    }
  }

  onMounted(getPreconditionFormItems)

  return {
    preconditionRef,
    preconditionData,
    preconditionForm,
    setPreconditionData,
  }
}
